import type { MutateSelectedFailure } from '../../hooks/useBillingCycles';
import {
  getBusinessErrorMessage,
  getResponseDetail,
} from '../../utils/apiErrorDetail';

type ShowErrorFn = (title: string, message: string) => void;

const CLAIM_SEND_FALLBACK =
  'Unexpected error occurred. Please try again or contact support.';

/**
 * A clearinghouse rejection's message names the refused field but not the
 * patient, unlike the chart-level messages, which carry their own identity.
 */
const isClearinghouseRejection = (error: unknown): boolean => {
  const detail = getResponseDetail(error);
  return (
    typeof detail === 'object' &&
    detail !== null &&
    (detail as { error_code?: unknown }).error_code === 'stedi_rejected'
  );
};

export const showSendBillingCycleFailures = (
  failures: MutateSelectedFailure[],
  showError: ShowErrorFn
) => {
  const lines = failures.map(failure => {
    const reason =
      getBusinessErrorMessage(failure.error) ?? CLAIM_SEND_FALLBACK;
    if (
      reason === CLAIM_SEND_FALLBACK ||
      isClearinghouseRejection(failure.error)
    ) {
      const id = failure.mrn
        ? `${failure.name} (MRN ${failure.mrn})`
        : failure.name;
      return `• ${id}: ${reason}`;
    }
    return `• ${reason}`;
  });

  showError(
    'Some billing cycles failed to send',
    `The following billing cycles could not be sent. Fix the chart and try again:\n${lines.join('\n')}`
  );
};
